import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import './InvoicePtcPreviewModal.css';

const InvoicePtcPreviewModal = ({
  show,
  pdfUrl,
  loading,
  error,
  warning,
  onClose,
  onDownload,
  title = 'Vista previa — Invoice PTC',
  iframeTitle = 'Vista previa Invoice PTC',
  showVariantSwitch = false,
  selectedVariant = 'PTC',
  onSelectVariant,
}) => (
  <Modal
    show={show}
    onHide={onClose}
    size="xl"
    centered
    scrollable
    backdrop="static"
    className="invoice-ptc-preview-modal"
    backdropClassName="invoice-ptc-preview-backdrop"
  >
    <Modal.Header closeButton>
      <Modal.Title className="d-flex align-items-center gap-3 flex-wrap">
        <span>{title}</span>
        {showVariantSwitch ? (
          <div className="d-flex align-items-center gap-2">
            <Button
              size="sm"
              variant={selectedVariant === 'PTC' ? 'primary' : 'outline-primary'}
              onClick={() => onSelectVariant?.('PTC')}
            >
              Invoice PTC
            </Button>
            <Button
              size="sm"
              variant={selectedVariant === 'PTB' ? 'primary' : 'outline-primary'}
              onClick={() => onSelectVariant?.('PTB')}
            >
              Invoice PTB
            </Button>
          </div>
        ) : null}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="p-0" style={{ minHeight: '70vh' }}>
      {loading ? (
        <div className="d-flex flex-column align-items-center justify-content-center py-5 gap-2">
          <Spinner animation="border" size="sm" />
          <span className="text-muted small">Generando PDF…</span>
        </div>
      ) : null}
      {error ? (
        <p className="text-danger small px-3 py-2 mb-0" style={{ whiteSpace: 'pre-wrap' }}>
          {error}
        </p>
      ) : null}
      {warning ? (
        <p
          className="text-warning-emphasis small px-3 py-2 mb-0 bg-warning-subtle border-bottom"
          style={{ whiteSpace: 'pre-wrap' }}
        >
          {warning}
        </p>
      ) : null}
      {!loading && pdfUrl ? (
        <iframe
          key={pdfUrl}
          title={iframeTitle}
          src={pdfUrl}
          style={{ width: '100%', height: '75vh', border: 'none' }}
        />
      ) : null}
      {!loading && !pdfUrl ? (
        <p className="text-muted small px-3 py-4 mb-0">
          {error || 'No hay vista previa disponible.'}
        </p>
      ) : null}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onClose}>
        Cerrar
      </Button>
      <Button variant="primary" onClick={onDownload} disabled={!pdfUrl || loading}>
        Descargar PDF
      </Button>
    </Modal.Footer>
  </Modal>
);

export default InvoicePtcPreviewModal;
